const __WEBPACK_NAMESPACE_OBJECT__ = require("sitemap-xml-webpack-plugin");;